var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.961,
    height: 14.75,
    viewBox: "0 0 12.961 14.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16773",
    "data-name": "Rectangle 16773",
    width: 12.961,
    height: 14.75,
    fill: "#1ebcc2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16666",
    "data-name": "Group 16666",
    transform: "translate(4749 672.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16606",
    "data-name": "Group 16606",
    transform: "translate(-4749 -672.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16605",
    "data-name": "Group 16605",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41425",
    "data-name": "Path 41425",
    d: "M6.482,156.06H.521c-.365,0-.526-.164-.521-.528a5.683,5.683,0,0,1,4.762-5.513,5.121,5.121,0,0,1,.745-.062q.936-.013,1.872,0a5.652,5.652,0,0,1,5.378,4.154,5.753,5.753,0,0,1,.2,1.406c.007.386-.15.546-.532.546H6.482",
    transform: "translate(0.001 -141.31)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41426",
    "data-name": "Path 41426",
    d: "M48.874,7.778A3.889,3.889,0,1,1,52.76,3.893a3.9,3.9,0,0,1-3.886,3.885",
    transform: "translate(-42.39 0)",
    fill: "#1ebcc2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.69f39005370d9c16969f1500bcc32719.svg";
export { ForwardRef as ReactComponent };